<!-- 新的文档中心 -->
<template>
	<div class="content_wrap">
		<div class="warp_box clearfix">
			<div class="left_box">
				<div class="title">文档中心</div>
			</div>
			<a-table :locale="{ emptyText: '暂无数据' }" bordered :data-source="dataSource" :columns="columns">
				<span slot="operation" slot-scope="text,record">
					<a href="javascript:;" @click="() => onPreview(record)"> 预览 </a>
					<a href="javascript:;" @click="() => onDownload(record)"> 下载 </a>
				</span>
			</a-table>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	name: 'documentCenter',
	data() {
		return {
			dataSource: [],
			columns: [
				{
					title: '文件名称',
					dataIndex: 'name',
				},
				{
					title: '上传时间',
					dataIndex: 'createTime',
					customRender: (text) => {
						return moment(text).format('YYYY-MM-DD')
					}
				},
				{
					title: '更新时间',
					dataIndex: 'updateTime',
					customRender: (text) => {
						return moment(text).format('YYYY-MM-DD')
					}
				},
				{
					title: '接入类型',
					dataIndex: 'accessType',
					customRender: (text) => {
						return {
							BWY: '百望云',
							GXZX: '广西征信',
							WXZX: '无锡征信',
							SHZX: '上海征信',
							QZJJM: '前置加解密'
						}[text]
					}
				},
				{
					title: '文档类型',
					dataIndex: 'type',
					customRender: (text) => {
						return {
							STANDARD: '标准',
							CUSTOM: '定制',
							INFO: '说明型',
							SDK: 'SDK'
						}[text]
					}
				},
				{
					title: '备注',
					dataIndex: 'remark',
				},
				{
					title: '操作',
					dataIndex: 'operation',
					scopedSlots: { customRender: 'operation' },
				},
			],
		}
	},
	mounted() {
		this.getTableList()
	},
	methods: {
		getTableList(params = {}) {
			let { pageNumber = 1, pageSize = 10 } = params
			this.http.post('/ystOpenPlatformBff/doc/queryDocList', {}, res => {
				if (res.success) {
					this.dataSource = res.data.list
					this.batchStatus = res.data.status
				} else {
					this.$message.warning(res.message)
					this.dataSource = []
					this.batchStatus = ''
				}
			})
		},
		async download(bytes, fileName) {
			const blob = new Blob([bytes], { type: 'application/pdf;chartset=UTF-8' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(link.href);
		},
		// 页面修改
		pageOnChange(page) {
			let params = {
				pageNumber: page.current,
				pageSize: page.pageSize
			}
			this.getTableList(params)
		},
		// 点击了表格中的某一行操作
		async onPreview(val) {
			this.http.post('/ystOpenPlatformBff/doc/handlePreview', { fileName: val.ossKey, id: val.id }, res => {
				if (res.success) {
					window.open(res.data[val.ossKey], '_blank')
				} else {
					this.$message.warning(res.message)
				}
			})
		},
		onDownload(val) {
			this.http.post('/ystOpenPlatformBff/doc/handleDownload', { fileName: val.ossKey, id: val.id }, res => {
				if (res.success) {
					var binary_string = window.atob(res.data[val.ossKey]);//解码使用base64编码的字符串
					var len = binary_string.length;			//获取长度
					var bytes = new Uint8Array(len);
					for (var i = 0; i < len; i++) {
						bytes[i] = binary_string.charCodeAt(i);
					}
					this.download(bytes, val.name)
				} else {
					this.$message.warning(res.message)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.content_wrap {
	background: $backg;
	padding: 30px 0;

	.warp_box {
		position: relative;
		width: 1200px;
		margin: 0 auto;
		background: $white;
		padding: 20px;
	}

	.left_box {
		width: 220px;
		font-size: 14px;
		margin-bottom: 12px;
		color: $gredF;
		line-height: 40px;

		/*border-right: 1px solid $border;*/
		.title {
			color: $title;
			padding-left: 20px;
			border-bottom: 1px solid $border;
		}

		.list {
			padding-top: 10px;
			min-height: 827px;
		}

		.active {
			background: $white;
			color: $hover;
			border-right: 3px solid $hover;
		}

		.title_active {
			background: $white;
			color: $hover;
			border-right: 1px solid $border;
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/page/DocumentCenter.vue